import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "label", "status"]

  static values = {
    text: String,
    defaultLabel: String,
    copiedLabel: { type: String, default: "Copied!" },
    failedLabel: { type: String, default: "Copy failed" }
  }

  connect() {
    this.resetState()
  }

  disconnect() {
    this.clearResetTimer()
  }

  copy(event) {
    event.preventDefault()
    this.clearResetTimer()

    this.copyToClipboard(this.textValue)
      .then(() => this.showCopiedState())
      .catch(() => this.showFailedState())
  }

  copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
      return navigator.clipboard.writeText(text)
    }

    return new Promise((resolve, reject) => {
      const textarea = document.createElement("textarea")
      textarea.value = text
      textarea.setAttribute("readonly", "")
      textarea.style.position = "fixed"
      textarea.style.top = "0"
      textarea.style.left = "0"
      textarea.style.opacity = "0"
      textarea.style.pointerEvents = "none"

      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      textarea.setSelectionRange(0, textarea.value.length)

      try {
        const copied = document.execCommand("copy")
        document.body.removeChild(textarea)

        if (copied) {
          resolve()
        } else {
          reject(new Error("Copy command was rejected"))
        }
      } catch (error) {
        document.body.removeChild(textarea)
        reject(error)
      }
    })
  }

  showCopiedState() {
    this.element.classList.remove("is-error")
    this.element.classList.add("is-copied")
    this.swapIcon("fa-check")
    this.labelTarget.textContent = this.copiedLabelValue
    this.statusTarget.textContent = `${this.defaultLabelValue} copied to clipboard.`
    this.resetTimer = setTimeout(() => this.resetState(), 1800)
  }

  showFailedState() {
    this.element.classList.remove("is-copied")
    this.element.classList.add("is-error")
    this.swapIcon("fa-exclamation-circle")
    this.labelTarget.textContent = this.failedLabelValue
    this.statusTarget.textContent = `Failed to copy ${this.defaultLabelValue}.`
    this.resetTimer = setTimeout(() => this.resetState(), 2200)
  }

  resetState() {
    this.element.classList.remove("is-copied", "is-error")
    this.swapIcon("fa-clipboard")
    this.labelTarget.textContent = this.defaultLabelValue
    this.statusTarget.textContent = ""
  }

  swapIcon(nextIconClass) {
    this.iconTarget.className = `fa ${nextIconClass} copyable-chip__icon`
  }

  clearResetTimer() {
    if (this.resetTimer) {
      clearTimeout(this.resetTimer)
      this.resetTimer = null
    }
  }
}
